import type { SVGProps } from 'react';
const DawnFlagGR = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect
      width={21.5}
      height={15.5}
      x={0.25}
      y={0.25}
      fill="#fff"
      stroke="#F5F5F5"
      strokeWidth={0.5}
      rx={1.75}
    />
    <mask
      id="dawn-flag-GR_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-GR_svg__a)">
      <path
        fill="#1C6DC1"
        fillRule="evenodd"
        d="M4.19 0H0v4.267h4.19zm6.286 0h-4.19v4.267h4.19V6.4h-4.19v4.267H22V8.533H10.476V6.4H22V4.267H10.476V2.133H22V0zM22 12.8H0v2.133h22zM4.19 6.4H0v4.267h4.19z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagGR;
